import { render, staticRenderFns } from "./shortVideo.vue?vue&type=template&id=7a81e494&scoped=true"
import script from "./shortVideo.vue?vue&type=script&lang=js"
export * from "./shortVideo.vue?vue&type=script&lang=js"
import style0 from "./shortVideo.vue?vue&type=style&index=0&id=7a81e494&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a81e494",
  null
  
)

export default component.exports